module.exports = __webpack_public_path__ + "img/ModularWallV.239ef671.jpg";